<template>
  <div class="modeRec">
    <div class="modeRec_header">
      <h3>审核意见</h3>
    </div>
    <div class="modeRec_main">
      <div
        class="modeRec_main_item"
        v-for="(item, index) in recList"
        :key="index"
      >
        <div class="item_header">
          <span :class="{ item_shzt: true, tg: item.shzt == 1 }">
            {{ item.shzt == 1 ? "通过" : "不通过" }}
          </span>
          <div class="item_title">
            <h3 class="item_shr">操作人：{{ item.shr ? item.shr : "-" }}</h3>
            <p class="item_shsj">{{ item.shsj ? item.shsj : "-" }}</p>
          </div>
        </div>
        <div class="item_shyj">
          <div class="item_shyj_text" v-if="item.shyj">{{ item.shyj }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    recList: {
      type: Array,
      default: () => []
    }
  },
  created() {}
};
</script>
<style lang="less" scoped>
.modeRec {
  background: #ffffff;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  .modeRec_header {
    box-sizing: border-box;
    height: 45px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    border-bottom: 1px solid #e5e5e5;
    h3 {
      position: relative;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 400;
      line-height: 22px;
      padding-left: 12px;

      &::before {
        content: "";
        position: absolute;
        border-radius: 2px;
        border-left: 4px solid #7469f8;
        height: 16px;
        top: 3px;
        left: 0;
      }
    }
  }
  .modeRec_main {
    padding: 20px 15px 0;
    .modeRec_main_item {
      display: flex;
      flex-direction: column;
      .item_header {
        width: 100%;
        display: flex;
        .item_shzt {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 42px;
          height: 42px;
          background: #f85352;
          font-size: 12px;
          border-radius: 4px;
          margin-right: 10px;
          font-family: PingFangSC-Regular;
          color: #ffffff;
          letter-spacing: 0;
          text-align: center;
          line-height: 14px;
          font-weight: 400;
          &.tg {
            background: #7469f8;
            font-size: 14px;
          }
        }
        .item_title {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .item_shr {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #333333;
            letter-spacing: 0;
            line-height: 16px;
            font-weight: 400;
          }
          .item_shsj {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #999999;
            letter-spacing: 0;
            line-height: 14px;
            font-weight: 400;
          }
        }
      }
      .item_shyj {
        position: relative;
        padding: 10px 0 26px 52px;

        .item_shyj_text {
          background: #f2f2f4;
          border-radius: 444px;
          padding: 10px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #666666;
          letter-spacing: 0;
          line-height: 20px;
          font-weight: 400;
        }
        &::before {
          content: "";
          position: absolute;
          left: 20px;
          top: 6px;
          bottom: 6px;
          border-left: 2px solid #d9d9d9;
        }
      }

      &:last-child {
        .item_shyj::before {
          display: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/xjydsh/mode/modeRec.vue